module.exports = __webpack_public_path__ + "static/img/default.510b38b0.png";